import type { ErrorSource } from './observability.types';

/**
 * Contador de tentativas por etapa do funil.
 *
 * Persistido em `sessionStorage`: em memória zeraria no reload, que é o caso que
 * interessa — o botão desabilitado já cobre o clique duplo.
 */
const STORAGE_KEY = 'checkout:observability:attempts';

let memoryFallback: Record<string, number> = {};

function readAll(): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, number>) : {};
  } catch {
    return memoryFallback;
  }
}

function writeAll(counters: Record<string, number>): void {
  memoryFallback = counters;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(counters));
  } catch {
    // Só memória então.
  }
}

/** Chamar no início da operação, não no erro: senão não conta as que deram certo. */
export function trackAttempt(source: ErrorSource): number {
  const counters = readAll();
  const next = (counters[source] ?? 0) + 1;
  writeAll({ ...counters, [source]: next });
  return next;
}

export function getAttempt(source: ErrorSource): number | undefined {
  return readAll()[source];
}

/** Existe para os testes. */
export function resetAttempts(): void {
  memoryFallback = {};
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nada a limpar.
  }
}
